<template>
  <div class="profilev2">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">收貨資訊</a>
      </nav>

      <!--  /////////////////////////////// -->

      <div class="card mt-1">
        <div class="card-body">
          <div class="title">台灣收貨資訊</div>
          <div class="form-group">
            <p style="text-align: left">更多選擇:</p>
            <b-form-radio
              v-model="orderTransferSelected"
              name="orderTransferSelected-radios"
              value="self"
              >自己購買</b-form-radio
            >
            <b-form-radio
              v-model="orderTransferSelected"
              name="orderTransferSelected-radios"
              value="other"
              >直接寄給我的客人</b-form-radio
            >
          </div>
          <div class="form-group">
            <label style="text-align: left" for="name"
              >取件人姓名（貨到付款取貨須[出示證件]，請填寫取件人證件上之名字）：</label
            >
            <input
              type="text"
              class="form-control"
              id="userName"
              aria-describedby="nameHelp"
              placeholder="收貨人姓名"
              v-model="from.name"
            />
          </div>
          <div class="form-group">
            <label style="text-align: left" for="phone"
              >取件人手機（商品抵達門市會以簡訊通知，請務必注意訊息（EX:09
              開頭））：</label
            >
            <input
              type="number"
              class="form-control"
              id="userPhone"
              placeholder="收貨人電話"
              v-model="from.phone"
            />
          </div>
          <div class="form-group">
            <label style="text-align: left" for="email"
              >電子郵件（訂單狀態通知用）：</label
            >
            <input
              type="text"
              class="form-control"
              id="userEmail"
              placeholder="電子郵件"
              v-model="from.email"
            />
          </div>
          <div v-if="orderTransferSelected == 'other'" class="form-group">
            <label style="text-align: left" for="identity"
              >客人身分證字號 (過海關需要）：</label
            >
            <input
              type="text"
              class="form-control"
              id="identity"
              placeholder="身分證字號"
              v-model="from.identity"
            />
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="title">國際收貨資訊</div>
          <div class="form-group">
            <p style="text-align: left">國際運輸方式:</p>
            <b-form-radio
              v-model="internationalTransportationSelected"
              name="internationalTransportation-radios"
              value="空運"
              >空運 (食品僅限空運)</b-form-radio
            >
            <b-form-radio
              v-model="internationalTransportationSelected"
              name="internationalTransportation-radios"
              value="海快"
              >海快 (需超過10公斤)</b-form-radio
            >
          </div>
          <div class="form-group">
            <p style="text-align: left">海關稅收:</p>
            <div v-if="internationalTransportationSelected == '空運'">
              <b-form-radio v-model="taxSelected" name="tax-radios" value="包稅"
                >包稅</b-form-radio
              >
            </div>
            <div v-else>
              <b-form-radio
                v-model="taxSelected"
                name="tax-radios"
                id="notax-radios"
                value="不包稅"
                >不包稅</b-form-radio
              >
            </div>
          </div>
          <b-alert show style="text-align: left">
            運輸時間：
            <br />空運大約:2~3天 <br />海快大約:7~10天
          </b-alert>

          <div class="form-group">
            <label for="shippingTypeSelected">選擇取貨方式</label>
            <b-form-select
              v-model="shippingTypeSelected"
              :options="shippingTypeOptions"
            ></b-form-select>
          </div>

          <div v-show="isStoreShow">
            <div class="form-group">
              <div class="form-group col-md-12">
                <label for="inputStore">選擇超商：</label>
                <select
                  id="inputStore"
                  class="form-control"
                  v-model="selectedStore"
                >
                  <option
                    v-for="(storeOption, index) in storeOptions"
                    v-bind:key="(storeOption, index)"
                    v-bind:value="storeOption.value"
                  >
                    {{ storeOption.text }}
                  </option>
                </select>
              </div>
              <button
                class="btn btn-success btn-lg btn-block"
                @click="selectStore()"
              >
                +新增門市
              </button>
            </div>
            <div v-if="mapInfo != null">
              <label>取貨門市:{{ mapInfo.cvs_store_name }}</label>
            </div>
            <div v-if="mapInfo != null">
              <label>取貨門市地址:{{ mapInfo.cvs_address }}</label>
            </div>
            <div v-if="mapInfo != null">
              <label>取貨門市編號:{{ mapInfo.cvs_store_id }}</label>
            </div>
            <b-alert show variant="danger" style="text-align: left"
              >注意超商取貨重量不能超過5公斤，商品長x寬x高不能超過(45x30x30)，加收40元派送費</b-alert
            >
          </div>

          <div v-show="ishomeDeliveryShow">
            <div class="form-group">
              <label for="phone">取件人地址</label>
              <input
                type="text"
                class="form-control"
                id="userAddress"
                placeholder="取件人地址"
                v-model="from.address"
              />
              <b-alert
                show
                variant="danger"
                class="mt-3"
                style="text-align: left"
                >注意宅配重量不能超過70公斤，商品長x寬x高不能超過(150x150x150)</b-alert
              >
            </div>
          </div>

          <b-alert show variant="danger" style="text-align: left">
            外島地區 澎湖、馬祖、綠島、小琉球、蘭嶼、金門 地區
            5KG以下加收100元，5KG以上加收120元，20KG以上加收330元
            <br />如果材積重量大於實際重量*2，將會以 (材積重量 + 實際重量)/2
            公斤做計算
          </b-alert>
        </div>
      </div>

      <br />
      <button class="btn btn-danger btn-lg btn-block" @click="submit()">
        確認收貨資訊，送出委託單
      </button>
      <br />
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.prod-block {
  /* background-color: #ff0000; */
}

.prod-text {
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px; */
}

.title {
  font-size: x-large;
  padding: 10px 0px;
}

.sale-price {
  color: #ff0000;
}

.noProd {
  font-size: 30px;
  color: red;
}

.padding-top-block {
  padding-top: 10px;
}

.calculation-text {
  font-size: 13px;
  color: red;
}

.w-400 {
  /* width: 100%;
  height: 200px; */
  height: 200px;
  width: 200px;
  width: 100%;
  /* object-fit: cover; */
  /* width: 400px;
  height: 500px; */
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'profilev2',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      webhookApiUrl: process.env.VUE_APP_WEBHOOK_API_URL,
      displayViews: null,
      isLoading: true,
      mapInfo: null,
      amounts: [],
      orders: [],
      profileInfo: {},
      userOrders: {},
      orderId: '',
      from: {
        name: '',
        phone: '',
        address: '',
        email: '',
        identity: '',
      },
      isStoreShow: false,
      ishomeDeliveryShow: true,
      shippingTypeSelected: 'delivery',
      shippingTypeOptions: [
        {
          value: 'deliveryStore',
          text: '超商取貨',
        },
        {
          value: 'delivery',
          text: '宅配',
        },
      ],
      skuSelected: '',
      selectedStore: 'UNIMARTC2C',
      checkMobile: isMobile ? '1' : '0',
      storeOptions: [
        {
          text: '7-11 超商（7-11）',
          value: 'UNIMARTC2C',
        },
      ],
      internationalTransportationSelected: '空運',
      taxSelected: '包稅',
      orderTransferSelected: 'self',
    }
  },
  methods: {
    submit: function () {
      const vm = this
      if (vm.from.name == '') {
        vm.$toast.open({
          message: '請輸入收件人姓名',
          type: 'error',
        })
        return 0
      }
      if (vm.from.phone == '') {
        vm.$toast.open({
          message: '請輸入收件人電話',
          type: 'error',
        })
        return 0
      }

      if (vm.from.email == '') {
        vm.$toast.open({
          message: '請輸入電子郵件',
          type: 'error',
        })
        return 0
      }

      if (vm.from.address == '' && vm.mapInfo == null) {
        vm.$toast.open({
          message: '請輸入收件資訊',
          type: 'error',
        })
        return 0
      }

      if (vm.from.address != '') {
        localStorage.setItem('address', vm.from.address)
        let formDataProfile = {
          userId: localStorage.userId,
          userAddress: vm.from.address,
        }

        axios
          .post(vm.apiUrl + 'UpdateProfileForAddress', formDataProfile, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function () {
            // console.log(response.data);
            // vm.isLoading = false;
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '失敗: ' + error,
              type: 'error',
            })
            vm.isLoading = false
          })
      }

      if (vm.from.email != '') {
        localStorage.setItem('email', vm.from.email)
        let formDataProfile = {
          userId: localStorage.userId,
          email: vm.from.email,
        }

        axios
          .post(vm.apiUrl + 'UpdateProfileForEmail', formDataProfile, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function () {
            // console.log(response.data);
            // vm.isLoading = false;
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '失敗: ' + error,
              type: 'error',
            })
            vm.isLoading = false
          })
      }

      if (vm.profileInfo != undefined) {
        ;(async function postapi() {
          vm.isLoading = true

          vm.$toast.open({
            message: '建立委託單中，請稍等片刻...',
            type: 'success',
          })
          let date = new Date()
          let nowUtc = Date.UTC(
            date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate(),
            date.getUTCHours(),
            date.getUTCMinutes(),
            date.getUTCSeconds(),
            date.getUTCMilliseconds()
          )
          let epochMilliSeconds = nowUtc.toString()

          let dd = date.getDate()
          let mm = date.getMonth() + 1
          let yyyy = date.getFullYear()
          if (dd < 10) {
            dd = '0' + dd
          }
          if (mm < 10) {
            mm = '0' + mm
          }
          let toDate = yyyy + '/' + mm + '/' + dd

          let formData = {
            orders: vm.orders,
            vender_info: vm.SortOrdersToVender(vm.orders),
            status: 0,
            user_id: localStorage.userId,
            user_name: localStorage.userName,
            user_image: localStorage.userImage,
            logistics_info: {
              international_transportation:
                vm.internationalTransportationSelected,
              tax: vm.taxSelected,
            },
            product_delivery: vm.shippingTypeSelected,
            user_order_name: vm.from.name,
            user_phone: vm.from.phone,
            map_info: vm.mapInfo,
            user_email: vm.from.email,
            user_address: vm.from.address,
            user_identity: vm.from.identity,
            total: 0,
            creat_date: epochMilliSeconds,
            creat_date_display: toDate,
            order_transfer_selected: vm.orderTransferSelected,
            version: 'v2',
          }
          // console.log("AddOrder: " + JSON.stringify(formData));
          await axios
            .post(vm.apiUrl + 'AddOrderV2', formData, {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
              },
            })
            .then(function (response) {
              if (Object.keys(response.data).length != 0) {
                vm.orderId = response.data.orderId
                vm.$toast.open({
                  message: '建立委託單完成!',
                  type: 'success',
                })

                // call webhook
                vm.sendBidFbMessageConsumer(localStorage.userId, vm.orderId)
                vm.$router.push('orderdonev2')
              }
              // console.log(response.data);
              vm.isLoading = false
            })
            .catch(function (error) {
              // console.log(error);
              vm.$toast.open({
                message: '失敗: ' + error,
                type: 'error',
              })
              vm.isLoading = false
            })
        })()
      } else {
        vm.$toast.open({
          message: '送出失敗',
          type: 'error',
        })
        vm.$modal.show('dialog', {
          title: '🙋請聯絡客服',
          text: '請聯絡客服⚡ 系統異常!',
          buttons: [
            {
              title: '👉聯絡客服',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })
      }
    },
    selectStore: function () {
      const vm = this
      if (vm.checkMobile == '1' && vm.selectedStore == 'UNIMARTC2C') {
        window.open(
          vm.apiUrl +
            'CepayMap?userId=' +
            localStorage.userId +
            '&logisticsSubType=' +
            vm.selectedStore +
            '&device=1'
        )
      } else if (vm.checkMobile == '0' && vm.selectedStore == 'UNIMARTC2C') {
        window.open(
          vm.apiUrl +
            'CepayMap?userId=' +
            localStorage.userId +
            '&logisticsSubType=' +
            vm.selectedStore +
            '&device=0'
        )
      } else {
        window.open(
          vm.apiUrl +
            'CepayMap?userId=' +
            localStorage.userId +
            '&logisticsSubType=' +
            vm.selectedStore +
            '&device=0'
        )
      }
    },
    queryMapInfo: function () {
      const vm = this
      let formData = {
        userId: localStorage.userId,
      }
      axios
        .post(vm.apiUrl + 'QueryMapInfo', formData, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        })
        .then(function (response) {
          if (Object.keys(response.data).length != 0) {
            vm.mapInfo = response.data
            localStorage.setItem('mapInfo', vm.mapInfo)
          } else {
            vm.mapInfo = JSON.parse(localStorage.getItem('mapInfo'))
          }

          // console.log(response.data);
          vm.isLoading = false
        })
        .catch(function (error) {
          // console.log(error);
          vm.$toast.open({
            message: '失敗: ' + error,
            type: 'error',
          })
          vm.isLoading = false
        })
    },
    SortOrdersToVender: function (orders) {
      let result = new Set()
      let repeat = new Set()

      orders.forEach(item => {
        result.has(item.prod_vender)
          ? repeat.add(item.prod_vender)
          : result.add(item.prod_vender)
      })

      let venderResults = []
      result.forEach(vender => {
        venderResults.push({ name: vender, package_weight: 0 })
      })

      return venderResults
    },
    sendBidFbMessageConsumer: function (userId, orderId) {
      const vm = this

      ;(async function post() {
        let formData = {
          userId: userId,
          tempType: 'apply_order',
          orderId: orderId,
        }
        await axios
          .post(vm.webhookApiUrl + 'SendMsgButtonTemplate', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            var data = response.data
            if (data.result == 'ok') {
              vm.$toast.open({
                message: '發送訊息!',
                type: 'success',
              })
            }
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '發送訊息失敗: ' + error,
              type: 'error',
            })
          })
      })()
    },
  },
  watch: {
    'from.name': function () {
      const vm = this
      localStorage.setItem('name', vm.from.name)
    },
    'from.phone': function () {
      const vm = this
      localStorage.setItem('phone', vm.from.phone)
    },
    'from.address': function () {
      const vm = this
      localStorage.setItem('address', vm.from.address)
    },
    'from.email': function () {
      const vm = this
      localStorage.setItem('email', vm.from.email)
    },
    internationalTransportationSelected: function () {
      const vm = this
      if (vm.internationalTransportationSelected == '空運') {
        vm.taxSelected = '包稅'
      }
      if (vm.internationalTransportationSelected == '海快') {
        vm.taxSelected = '不包稅'
      }
    },
    taxSelected: function () {
      const vm = this
      if (
        vm.taxSelected == '不包稅' &&
        vm.internationalTransportationSelected == '空運'
      ) {
        alert('目前空運不支援不包稅')
      }
      if (
        vm.taxSelected == '包稅' &&
        (vm.internationalTransportationSelected ==
          '海快 (未滿10公斤以10公斤計算)' ||
          vm.internationalTransportationSelected == '海快')
      ) {
        alert('目前海快不支援包稅')
      }
    },
    shippingTypeSelected: function () {
      const vm = this
      if (vm.shippingTypeSelected == 'deliveryStore') {
        vm.isStoreShow = true
        vm.ishomeDeliveryShow = false
      } else {
        vm.isStoreShow = false
        vm.ishomeDeliveryShow = true
      }
    },
    queryProfile: function () {
      const vm = this
      const isValid = 1

      let formData = {
        userId: localStorage.userId,
        isValid: isValid,
      }

      axios
        .post(vm.apiUrl + 'QueryProfile', formData, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        })
        .then(function (response) {
          if (Object.keys(response.data).length != 0) {
            if (response.data[0] != null) {
              vm.profileInfo = response.data[0]

              vm.profileInfo.user_name = vm.from.name
              vm.profileInfo.user_address = vm.from.address
              vm.profileInfo.user_phone = vm.from.phone
              vm.profileInfo.email = vm.from.email
            }
          }
          // console.log(response.data);
          vm.isLoading = false
        })
        .catch(function (error) {
          // console.log(error);
          vm.$toast.open({
            message: '讀取會員失敗: ' + error,
            type: 'error',
          })
        })
    },
  },
  computed: {},
  mounted() {
    const vm = this
    vm.isLoading = true
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    vm.queryMapInfo()

    if (vm.$route.query.isStore == '1') {
      vm.shippingTypeSelected = 'deliveryStore'
      vm.isStoreShow = true
      vm.ishomeDeliveryShow = false
    }

    if (vm.$store.newprodInfos != undefined) {
      vm.orders = vm.$store.newprodInfos
    } else if (JSON.parse(localStorage.getItem('newprodInfos')) != undefined) {
      vm.orders = JSON.parse(localStorage.getItem('newprodInfos'))
    }

    if (vm.orders.length == 0) {
      vm.$modal.show('dialog', {
        title: '🙋請聯絡客服',
        text: '請聯絡客服⚡ 系統異常!',
        buttons: [
          {
            title: '👉聯絡客服',
            handler: () => {
              window.location = 'https://m.me/2266831083395361'
            },
          },
        ],
      })
    }

    if (localStorage.getItem('address') != undefined) {
      vm.from.address = localStorage.getItem('address')
    }
    if (localStorage.getItem('name') != undefined) {
      vm.from.name = localStorage.getItem('name')
    }
    if (localStorage.getItem('phone') != undefined) {
      vm.from.phone = localStorage.getItem('phone')
    }
    if (localStorage.getItem('email') != undefined) {
      vm.from.email = localStorage.getItem('email')
    }
    vm.queryProfile()
  },
}
</script>
